export class ConfigModel {

    private _fontSize: string = 'regular';

    public webServiceURL: string;
    public defaultCategory: string = 'R';
    public defaultFilters = {
        showSales: true,
        showRentals: true,
        showSuspended: true,
        showHistoricized: false
    }    
    public lastVersionInfo: string = '';

    // ToDo: eliminare i metodi accessori per "fontSize"
    public get fontSize(): string  {
        return this._fontSize;
    }

    // ToDo: eliminare i metodi accessori per "fontSize"
    // ToDo: **assolutamente** eliminare l'attivazione/disattivazione del foglio di stile 'small-fonts' in questo punto
    public set fontSize(value: string) {

        if (value != this.fontSize) {
            let s = document.getElementById('small-fonts');

            if ('small' == this.fontSize && s) {
                s.setAttribute('disabled', 'true');
            }

            this._fontSize = value;

            if ('small' == this.fontSize && s) {
                s.removeAttribute('disabled');
            }
        }
    } 
}


// WEBPACK FOOTER //
// ./src/models/config.model.ts